/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

import { getCombinedClassNames } from 'utils/style';

const ToggleDot = styled.div.attrs(() => {
  const classNamesToAdd = [
    'transition',
    'ease-in',
    'duration-300',
    'absolute',
    'bg-white',
    'rounded-full',
    'shadow',
    'inset-y-0',
    'left-0',
  ];

  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})`
  top: 2px;
  left: 2px;
  height: 26px;
  width: 26px;

  @media (min-width: ${({ theme }) => theme.screens.lg}) {
    top: 3px;
    left: 3px;
    height: 34px;
    width: 34px;
  }
`;

const ToggleBg = styled.div.attrs(() => {
  const classNamesToAdd = ['bg-primary-300', 'rounded-full'];

  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})`
  height: 30px;
  width: 60px;

  @media (min-width: ${({ theme }) => theme.screens.lg}) {
    height: 40px;
    width: 80px;
  }
`;

const Input = styled.input`
  &:checked ~ ${ToggleDot} {
    transform: translateX(30px);
    background-color: ${({ theme }) => theme.extend.colors.primary.default};

    @media (min-width: ${({ theme }) => theme.screens.lg}) {
      transform: translateX(40px);
    }
  }
`;

export { ToggleDot, ToggleBg, Input };
